import { useState } from 'react'

import { OutOfStockMessage } from './OutOfStockMessage'
import { QuantitySelector } from './QuantitySelector'
import { useCheckout, AddToCartButton } from '../../../../Checkout'
import { Skeleton, useProductViewSkeletonVariants } from '../../../../Theme'
import { AddToWishlistButton } from '../../../../Wishlist'
import { useProductAvailability } from '../../../hooks'
import { Translate } from '../../../lib/translate'
import { useProductAttributes } from '../../../state'

function AddToCartSkeleton() {
  const { skeletonSectionVariants } = useProductViewSkeletonVariants()

  return (
    <div className={skeletonSectionVariants({ section: 'addToCart' })}>
      <Skeleton size="xl" width="twoSixths" />
      <Skeleton size="xl" width="threeSixths" />
    </div>
  )
}

export function AddToCartSection() {
  const { errorMessage } = useCheckout()
  const [qty, setQty] = useState(1)

  const { loading, productSku } = useProductAttributes()
  const { isInStock, showAddToCart, isDiscontinued, isBundle } = useProductAvailability()

  if (loading) {
    return <AddToCartSkeleton />
  }

  if (isBundle) {
    return <div />
  }

  return (
    <div className="mt-0 mb-3 xl:mt-5 xl:mb-5 flex justify-left flex-col">
      <div className="flex justify-center xl:justify-start w-full">
        {!isInStock || !showAddToCart ? (
          <OutOfStockMessage showAddToCart={showAddToCart} hasCategory={isDiscontinued} />
        ) : (
          <div className="flex flex-row gap-4 w-full items-center">
            <QuantitySelector qty={qty} setQty={setQty} />
            <AddToCartButton
              sku={productSku}
              quantity={qty}
              className="h-[45px] w-4/5 xl:w-3/4 text-sm md:text-lg"
            />
            <AddToWishlistButton sku={productSku} />
          </div>
        )}
      </div>
      {errorMessage && (
        <div className="text-red-500 text-sm mt-3">
          <Translate message={errorMessage} />
        </div>
      )}
    </div>
  )
}
